import Sidemenu from '@blocks/Sidemenu'
import { useSidepanelContext } from '@contexts/sidepanel'
import { route } from '@helpers'
import useAuth from '@hooks/useAuth'
import React from 'react'

export default function MainSidemenu({ category }: Props) {
    const sidemenu = useSidepanelContext()
    const { user, isCustomer, hasDetails, isJury, isAdmin, logout } = useAuth()

    const onLogout = async () => {
        await sidemenu.close()
        logout()
    }

    return (
        <Sidemenu>
            {/* CUSTOMER */}
            <Sidemenu.Item label="Registration" to="" condition={isCustomer && !hasDetails} active={category === "details"} onClick={sidemenu.close} />
            <Sidemenu.Item label="Profile" to={route("customer:profile")} condition={isCustomer && hasDetails} active={category === "profile"} onClick={sidemenu.close} />
            <Sidemenu.Item label="Open" to={route("customer:current")} condition={isCustomer && hasDetails} active={category === "current"} onClick={sidemenu.close} count={"current_count" in user ? user.current_count : undefined} />
            <Sidemenu.Item label="Entries" to={route("customer:participating")} condition={isCustomer && hasDetails} active={category === "participating"} onClick={sidemenu.close} count={"participating_count" in user ? user.participating_count : undefined} />
            <Sidemenu.Item label="Results" to={route("customer:past")} condition={isCustomer && hasDetails} active={category === "past"} onClick={sidemenu.close} />
            <Sidemenu.Item label="Gallery" to={route("customer:gallery")} condition={isCustomer && hasDetails} active={category === "gallery"} onClick={sidemenu.close} />
            <Sidemenu.Item label="Settings" to={route("customer:settings")} condition={hasDetails && isCustomer} active={category === "settings"} onClick={sidemenu.close} />
            <Sidemenu.Item label="Support" to={route("general:support")} condition={hasDetails && isCustomer} newTab onClick={sidemenu.close} />
            {/* JURY */}
            <Sidemenu.Item label="Voting" to={route("jury")} condition={isJury} active={category === "voting"} onClick={sidemenu.close} />
            {/* ADMIN */}
            <Sidemenu.Item label="Salons" to={route("admin:salons")} condition={isAdmin} active={category === "salons"} onClick={sidemenu.close} />
            <Sidemenu.Item label="Customers" to={route("admin:customers")} condition={isAdmin} active={category === "customers"} onClick={sidemenu.close} />
            <Sidemenu.Item label="Juries" to={route("admin:juries")} condition={isAdmin} active={category === "juries"} onClick={sidemenu.close} />
            <Sidemenu.Item label="Organizations" to={route("admin:organizations")} condition={isAdmin} active={category === "organizations"} onClick={sidemenu.close} />
            <Sidemenu.Item label="Sections" to={route("admin:sections")} condition={isAdmin} active={category === "sections"} onClick={sidemenu.close} />
            <Sidemenu.Item label="Awards" to={route("admin:awards")} condition={isAdmin} active={category === "awards"} onClick={sidemenu.close} />
            <Sidemenu.Item label="Logs" to={route("admin:logs")} condition={isAdmin} active={category === "logs"} onClick={sidemenu.close} />
            {/* GENERAL */}
            <Sidemenu.Item label="Log out" to="#" onClick={onLogout} />
        </Sidemenu>
    )
}

interface Props {
    category: string
}